import "./Introduction.css";
function Introduction() {
	return (
		<section id="introduction" className="pt-5">
			<div className="h-100 pt-5">
				<div className="w-100 pt-5 mt-5 color-200">
					<h1 className="fs-1 bold text-center">
						Olá 👋, <br />
						Meu nome é <span className="color-accents-blue">Clayton</span>.
					</h1>
					<p className="text-center color-600 fs-5">
						Desenvolvedor
						<span className="color-accents-light-yellow"> Full Stack </span>,
						apaixonado por <span className="color-300">tecnologia</span> e
						<span className="color-300"> programação.</span>
						<br />
						Estou ansioso para enfrentar desafios e contribuir com soluções
						inovadoras!
					</p>
				</div>
			</div>

			<hr className="mt-5 w-75 mx-auto" />
		</section>
	);
}

export default Introduction;
